<template>
    <div class="header-container">
        <div class="header-wrapper">
            <div>
                <img style="cursor: pointer;" @click="to" src="@/assets/img/elogo.png" alt="" class="logo">
            </div>
            <div class="navbar-wrapper">
                <div v-for="(item, key) in navData" :key="'navbar-' + key" @click="handleNav(item)"
                    :class="activeNav == item.id ? 'navbar-item-active' : 'navbar-item'">
                    {{ item.name }}
                    <div v-if="activeNav == item.id" class="navbar-line"></div>
                </div>
                <div class="header-operate">
                    <div class="login-item">登录</div>
                    <div class="login-line"></div>
                    <div class="login-item">注册</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    components: {

    },
    data() {
        return {
            activeNav: 'courseSelect',
            navData: [
                {
                    id: 'courseSelect',
                    name: '选课'
                },
                {
                    id: 'courseMall',
                    name: '课程商城'
                },
                {
                    id: 'teacherHome',
                    name: '名师家园'
                },
                {
                    id: 'liveClass',
                    name: '直播课堂'
                },
                {
                    id: 'download',
                    name: '下载'
                }
            ]
        }
    },
    mounted() {
        this.$emit('navTarget', 'courseSelect');
    },
    methods: {
        to() {
            //window.location.href = 'https://hxt.saas.taxchina.com';
            window.open('https://hxt.saas.taxchina.com', '_blank');
        },
        handleNav(row) {
            this.activeNav = row.id;
            this.$emit('navTarget', row.id);
        }
    }
}
</script>

<style scoped>
.header-container {
    width: 100%;
    height: 100px;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 80;
}

.header-wrapper {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo {
    width: 165px;
    height: 57px;
}

.navbar-wrapper {
    height: 100%;
    display: flex;
}

.navbar-item {
    height: 100%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 35px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.navbar-item:hover {
    cursor: pointer;
    color: #3E63EE;
}

.navbar-item-active {
    height: 100%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 35px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.navbar-line {
    position: absolute;
    left: 0px;
    bottom: 0px;
    height: 4px;
    width: 100%;
    background: #3E63EE;
    border-radius: 2px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    animation: mymove 1s;
}

@keyframes mymove {
    from {
        opacity: 0.5;
    }

    to {
        opacity: 1;
    }
}

.header-operate {
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 20px;
}

.login-line {
    width: 1px;
    height: 14px;
    background: #333333;
    margin: 0px 10px 0px 10px;
    position: relative;
    top: 1px;
}

.login-item {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.login-item:hover {
    cursor: pointer;
    color: #3E63EE;
}
</style>


